import { render, staticRenderFns } from "./RotateSetting.vue?vue&type=template&id=65300f96&scoped=true"
import script from "./RotateSetting.vue?vue&type=script&lang=js"
export * from "./RotateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65300f96",
  null
  
)

export default component.exports